import React from 'react'

export const LabRequestLastUpdate = ({ date = 'No existe fecha', client = 'No existe cliente' }) => {
   
    if(client == null) { client = 'Sin información del usuario' }
    if(date == null) { date = 'No existe fecha' }

    return (
        <>
            <div className='d-flex align-items-center w-100'>
                <label className='text-success me-2'>Última Actualización:</label>
            </div>
            <div className='d-flex align-items-center w-100'>
                <label><span>{ client } / { date } </span></label>
            </div>
        </>
    )
}
